module.exports = __webpack_public_path__ + "static/media/p-user.296c94bd.svg";